<template>
    <tbody>
        <template v-if="formGroupLayout == 'row'">
            <tr>
                <td :class="`mb-0 fm-question`">
                    <div :class="`text-${choicePlacement('question')}`">
                        <span>{{ $t('managerForm.settingPage.pageTypeI.fieldMail') }}</span>
                        <span class="text-danger pl-1">{{ $t('common.fieldRequired') }}</span>
                    </div>
                </td>
                <td :class="`fm-answer text-${choicePlacement('answer')}`">
                    <template v-if="defineShowTypeBlock">
                        <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                            <div>
                                <div class="d-flex align-items-center" :style="`justify-content:${choicePlacement('answer')}`">
                                    <InputText
                                        :id="`InputText-Mail`"
                                        :model.sync="formInit.email"
                                        :config.sync="formConfig.email"
                                        :disabled="disabled"
                                        @change="
                                            () => {
                                                formInit.email = formInit.email?.trim();
                                            }
                                        "
                                        @blur="handleValidateField(formInit.email, formConfig.email)"
                                    />
                                    <span class="text-nowrap" style="opacity: 0; visibility: hidden">{{
                                        settingConfirmLabel ? settingConfirmLabel.label_required : $t('managerForm.settingPage.confirmation')
                                    }}</span>
                                </div>
                                <div
                                    v-if="isConfirmInputTwice"
                                    class="mt-3 d-flex align-items-center"
                                    :style="`justify-content:${choicePlacement('answer')}`"
                                >
                                    <InputText
                                        :id="`InputText-Mail-Confirmation`"
                                        :model.sync="formInit.mail_confirm"
                                        :config.sync="formConfig.email"
                                        :disabled="disabled"
                                        @change="
                                            () => {
                                                formInit.mail_confirm = formInit.mail_confirm?.trim();
                                            }
                                        "
                                        @blur="handleValidateField(formInit.mail_confirm, formConfig.mail_confirm)"
                                    />
                                    <span class="text-nowrap">{{
                                        settingConfirmLabel ? settingConfirmLabel.label_required : $t('managerForm.settingPage.confirmation')
                                    }}</span>
                                </div>
                                <div v-if="formConfig.email.error" :class="`form__alert--error text-${choicePlacement('answer')}`">
                                    {{ formConfig.email.errorField }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else>
                        {{ formInit.email }}
                    </div>
                </td>
            </tr>
        </template>
        <template v-else>
            <tr>
                <td colspan="2" :class="`mb-0 fm-question`">
                    <div :class="`text-${choicePlacement('question')}`">
                        <div>{{ $t('managerForm.settingPage.pageTypeI.fieldMail') }}</div>
                        <span class="text-danger pl-1">{{ $t('common.fieldRequired') }}</span>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="2" :class="`fm-answer text-${choicePlacement('answer')}`">
                    <template v-if="defineShowTypeBlock">
                        <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                            <div>
                                <div class="d-flex align-items-center" :style="`justify-content:${choicePlacement('answer')}`">
                                    <InputText
                                        :id="`InputText-Mail`"
                                        :model.sync="formInit.email"
                                        :config.sync="formConfig.email"
                                        :disabled="disabled"
                                        @change="
                                            () => {
                                                formInit.email = formInit.email?.trim();
                                            }
                                        "
                                        @blur="handleValidateField(formInit.email, formConfig.email)"
                                    />
                                    <span class="text-nowrap" style="opacity: 0; visibility: hidden">{{
                                        settingConfirmLabel ? settingConfirmLabel.label_required : $t('managerForm.settingPage.confirmation')
                                    }}</span>
                                </div>
                                <div
                                    v-if="isConfirmInputTwice"
                                    class="mt-3 d-flex align-items-center"
                                    :style="`justify-content:${choicePlacement('answer')}`"
                                >
                                    <InputText
                                        :id="`InputText-Mail-Confirmation`"
                                        :model.sync="formInit.mail_confirm"
                                        :config.sync="formConfig.email"
                                        :disabled="disabled"
                                        @change="
                                            () => {
                                                formInit.mail_confirm = formInit.mail_confirm?.trim();
                                            }
                                        "
                                        @blur="handleValidateField(formInit.mail_confirm, formConfig.mail_confirm)"
                                    />
                                    <span class="text-nowrap">{{ $t('managerForm.settingPage.confirmation') }}</span>
                                </div>
                                <div v-if="formConfig.email.error" :class="`form__alert--error text-${choicePlacement('answer')}`">
                                    {{ formConfig.email.errorField }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-else>
                        {{ formInit.email }}
                    </div>
                </td>
            </tr>
        </template>
    </tbody>
</template>

<script>
import { onHandleGetValueTextAlign, onHandleSetStyleLabel } from '../handlers';
import { onHandleMapMessage, onHandleMessKeypattern } from '../handleTypeI';
import { InputText } from '@/components/Input';
import { validateField } from '@/utils/validate_v2';
import { PAGE_TYPES } from '../../constants';

export default {
    name: 'CommonBoxMail',
    components: { InputText },
    props: {
        inforData: {
            type: Object,
            default: null
        },
        settingDesign: {
            type: Object,
            default: null
        },
        conditionPageShow: {
            type: String,
            default: null
        },
        formInit: {
            type: Object,
            default: null
        },
        formConfig: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: () => false
        },
        settingRequireLabel: {
            type: Object,
            default: () => null
        },
        settingConfirmLabel: {
            type: Object,
            default: () => null
        },
        isConfirmInputTwice: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        formGroupLayout() {
            return this.settingDesign.table_settings.question_layout === 'horizontal' ? 'row' : 'cols';
        },

        defineShowTypeBlock() {
            return [PAGE_TYPES._I[0]].includes(this.conditionPageShow);
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        onHandleSetStyleLabel,
        choicePlacement(type) {
            switch (type) {
                case 'question':
                    return onHandleGetValueTextAlign(this.settingDesign.table_settings.question_text_alignment.horizontal);
                case 'answer':
                    return onHandleGetValueTextAlign(this.settingDesign.table_settings.answer_text_alignment.horizontal);
            }
        },
        onHandleSetStyleQuestion(blockInfor) {
            return `${
                blockInfor.cell_background_color.is_bg_question_default ? '' : `background-color:${blockInfor?.cell_background_color?.bg_question}`
            } `;
        },
        onHandleSetStyleAnswer(blockInfor) {
            return `${
                blockInfor.cell_background_color.is_bg_answer_default ? '' : `background-color:${blockInfor?.cell_background_color?.bg_answer}`
            } `;
        },
        handleValidateField(valueField, configField) {
            validateField(valueField, configField);
            onHandleMapMessage(valueField, configField);
            onHandleMessKeypattern(this.formInit, this.formConfig, this.inforData);
        }
    },
    mounted() {
        this.index = this.index + 1;
    }
};
</script>

<style lang="scss" scoped></style>
